import {
  IsCardBeforePaidCutoffHandler,
  useIsCardBeforePaidCutoff,
} from '@shared/data/billing/hooks/useIsCardBeforePaidCutoff';
import {
  CardsEntityService,
  CardsEntityServiceProps,
  useCardService,
} from '@shared/data/cards/CardsEntityService';
import { OpenEntityHandler, useOpenEntityById } from './useOpenByEntityId';

export interface CollectionViewDataProps extends CardsEntityServiceProps {
  baseNavigationPath: string;
  dateComponentId?: string;
}

export interface CollectionViewData extends CardsEntityService {
  openEntity: OpenEntityHandler;
  getIsCardBeforePaidCutoff: IsCardBeforePaidCutoffHandler;
}

export function useCollectionViewData({
  workflowTemplateId,
  viewTemplateId,
  workspaceId,
  pageSize,
  baseNavigationPath,
  dateComponentId,
}: CollectionViewDataProps): CollectionViewData {
  const cardService = useCardService({
    workflowTemplateId,
    viewTemplateId,
    pageSize,
    workspaceId,
    dateComponentId,
  });
  const openEntity = useOpenEntityById(baseNavigationPath, workflowTemplateId);
  const getIsCardBeforePaidCutoff = useIsCardBeforePaidCutoff();

  return {
    ...cardService,
    openEntity,
    getIsCardBeforePaidCutoff,
  };
}
